export var DEFAULT_LOCALE = 'en';
export * from './substituteTokens';
export * from './TestTranslationProvider';
export * from './I18nContext';
export * from './I18nContextProvider';
export * from './TranslationMessages';
export * from './TranslatableContext';
export * from './TranslatableContextProvider';
export * from './TranslationUtils';
export * from './useLocaleState';
export * from './useLocale';
export * from './useLocales';
export * from './useSetLocale';
export * from './useTranslatable';
export * from './useTranslatableContext';
export * from './useTranslate';
export * from './useTranslateLabel';
export * from './useI18nProvider';
//# sourceMappingURL=index.js.map